import { getInfoLogger } from '@ori/checkout-utils';
import { parseClientAppConfig } from '@ori/client-app-config';

import { APP_NAME } from '../constants';
import type { ClientAppConfig } from '../types/ClientAppConfig';

const logInfo = getInfoLogger(APP_NAME);

/**
 * Parses the configuration for subscription wizard SPA component.
 * @param config Subscription wizard SPA root element.
 * @returns Subscription wizard component configuration.
 */
export const getConfiguration = (config: string) => {
  const result = parseClientAppConfig<ClientAppConfig>(config, [
    'currentLanguage',
    'customerId',
    'globalApiUrl',
    'identityUrl',
    'staticApiUrl',
    'tenant',
  ]);
  logInfo('getConfiguration', result);

  return result;
};
